import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import CreateProduct from "@/features/products/create-product";
import ProductsTable from "@/features/products/products-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/products/",
)({
  beforeLoad: ({ context }) => {
    const canReadProducts = context.ability.can("read", "Product");

    if (!canReadProducts) {
      console.error("User does not have permission to read products");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: ProductsPage,
});

function ProductsPage() {
  const { museumId } = Route.useParams();
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Produkt</Trans>
        </h1>

        <Can I="create" a="Product">
          <CreateProduct museumId={museumId} />
        </Can>
      </Flex>

      <ProductsTable museumId={museumId} />
    </Box>
  );
}
